module.exports = __webpack_public_path__ + "blackmind.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackmind.png
// module id = 861
// module chunks = 0